import { Typography, Container, Box, Stack, useTheme, } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { ReactElement } from 'react';


interface Feature {
   icon: ReactElement;
   title: string;
   description: string;
}

const features: Feature[] = [
   {
      icon: <AccessTimeIcon color="primary" />,
      title: 'We Are Here When You Need Us',
      description: `No matter your schedule, we make it easy to get your laundry done quickly and efficiently`
   },
   {
      icon: <LocalLaundryServiceIcon color="primary" />,
      title: 'Our Premises Are Clean',
      description: `Your laundry is clean and hygienic each time because we keep all the machines and the washing, drying, and folding areas spotless.`
   },
   {
      icon: <SmartToyIcon color="primary" />,
      title: 'We Use Smart Technology',
      description: `With us, you never have to compromise efficiency. Schedule laundry delivery and pickup on our app!`
   },
   {
      icon: <SupportAgentIcon color="primary" />,
      title: 'We Offer Top-notch Customer Service',
      description: `Our customer service practices are designed to offer exceptional support and assistance.`
   },
];



export const WhyChooseUs = () => {
   const theme = useTheme();

   return (
      <Box component="section" sx={{ backgroundColor: theme.palette.grey[100], py: 8 }}>
         <Container>
            <Typography
               variant="h4"
               sx={{
                  textAlign: 'center',
                  fontWeight: 700,
                  mb: 2,
               }}
            >
               Why Choose{' '}
               <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                  Us?
               </Box>
            </Typography>

            <Typography variant="body1" textAlign="center" mb={4}>
               There are many reasons why you should choose us for your laundry needs. Here are some top reasons:
            </Typography>

            <Stack spacing={4}>
               {features.map((item, index) => (
                  <Stack key={index} direction="row" spacing={3} alignItems="flex-start">
                     <Box mt={0.5}>{item.icon}</Box>
                     <Box>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                           {item.title}
                        </Typography>
                        <Typography>
                           {item.description}
                        </Typography>
                     </Box>
                  </Stack>
               ))}
            </Stack>

            <Typography marginTop={"2.5rem"} >
               We have established a reputation for reliability and convenience and are proud to meet people’s laundry needs at our laundromat in Hamilton East.
            </Typography>
         </Container>
      </Box>
   );
};
